import { Box, Typography } from "@mui/material"
import React from "react"

/**
 * Renders a filter item with an icon and label
 */
const FilterItem = React.memo(({ label, value }) => {
  const displayValue = value || "(none selected)"

  return (
    <Typography variant="body2" fontFamily="Poppins, Helvetica">
      <Box component="span" fontWeight={600}>
        {label}:
      </Box>{" "}
      <Box component="span" color="text.secondary">
        {displayValue}
      </Box>
    </Typography>
  )
})

FilterItem.displayName = "FilterItem"

export default FilterItem
